import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsVirginIslands = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1575)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#FCFCFC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.0381 8.3834C14.0381 7.25784 13.1256 6.34537 12 6.34537C10.8744 6.34537 9.96191 7.25784 9.96191 8.3834H5.47827C5.47827 9.49157 6.44362 10.39 7.55179 10.39H7.48504C7.48504 11.4983 8.38335 12.3968 9.49171 12.3968C9.49171 13.378 10.1964 14.1934 11.1271 14.3676L11.1219 14.3794H12.8781L12.8729 14.3676C13.8037 14.1933 14.5083 13.378 14.5083 12.3968C15.6166 12.3968 16.515 11.4983 16.515 10.39H16.4482C17.5563 10.39 18.5217 9.49157 18.5217 8.3834H14.0381Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1041 14.1714L9.84045 17.0244C10.5072 17.2954 11.236 17.4461 12.0001 17.4461C12.7642 17.4461 13.493 17.2954 14.1597 17.0244L12.896 14.1714H11.1041Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.39136 9.38565V12.8962C9.39136 14.8929 12 15.5049 12 15.5049C12 15.5049 14.6087 14.8929 14.6087 12.8962V9.38565H9.39136Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.91 12.0845L4.32089 16.0306L5.71711 12.0845H6.78267L4.74708 17.3018H3.89465L1.84448 12.0845H2.91Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.3044 17.3018V12.0845H20.3185V17.3018H19.3044Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4348 10.5193V14.7734C10.7935 15.0373 11.1793 15.2189 11.4783 15.3351V10.5193H10.4348Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5652 10.5193V14.7734C13.2066 15.0373 12.8207 15.2189 12.5217 15.3351V10.5193H13.5652Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.39136 9.38556H14.6087V11.041H9.39136V9.38556Z",
				fill: "#0052B4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1575",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgUsVirginIslands;
